import { cn } from "@/lib/cn";

type Option = { value: string; label: string };

type SelectProps = Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "size"> & {
  label: string;
  size?: "sm" | "md";
  options: Option[];
  placeholder?: string;
};

/** 라벨 + 셀렉트. TextField 와 동일 스타일/사이즈 규칙. */
export function Select({ label, size = "md", options, placeholder, className, ...rest }: SelectProps) {
  const compact = size === "sm";
  return (
    <label className={cn("flex flex-col", compact ? "gap-1" : "gap-1.5")}>
      <span className={compact ? "text-xs text-muted" : "text-sm font-medium text-ink"}>
        {label}
      </span>
      <select
        className={cn(
          "rounded-[10px] border text-ink outline-none transition-colors focus:border-primary",
          compact ? "px-3 py-2 text-sm" : "px-3.5 py-2.5 text-[15px]",
          className
        )}
        style={{ borderColor: "var(--line)", background: "var(--surface-2)" }}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
